import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import '../../App.css';

const firebaseAuthUrl = 'https://identitytoolkit.googleapis.com/v1/accounts:resetPassword';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [status, setStatus] = useState('checking');
  const [error, setError] = useState('');
  const oobCode = searchParams.get('oobCode') || '';
  const apiKey = searchParams.get('apiKey') || '';

  useEffect(() => {
    if (!oobCode || !apiKey) {
      setError('This password link is incomplete. Request a new setup email.');
      setStatus('invalid');
      return;
    }
    fetch(`${firebaseAuthUrl}?key=${encodeURIComponent(apiKey)}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ oobCode }),
    })
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok) throw new Error(data.error && data.error.message);
        setEmail(data.email || '');
        setStatus('ready');
      })
      .catch(() => {
        setError('This password link is invalid or has expired. Request a new setup email.');
        setStatus('invalid');
      });
  }, [apiKey, oobCode]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    if (password.length < 10) {
      setError('Use at least 10 characters for your password.');
      return;
    }
    if (password !== confirmation) {
      setError('The passwords do not match.');
      return;
    }
    setStatus('saving');
    try {
      const response = await fetch(`${firebaseAuthUrl}?key=${encodeURIComponent(apiKey)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ oobCode, newPassword: password }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error && data.error.message);
      setStatus('complete');
    } catch (requestError) {
      setError('The password could not be saved. The link may have expired or already been used.');
      setStatus('ready');
    }
  };

  return (
    <main className='content-page password-page'>
      <section className='password-card'>
        <span className='brand-mark' aria-hidden='true'>M</span>
        <p className='section-kicker'>Mukwei Operations</p>
        <h1>{status === 'complete' ? 'Password secured.' : 'Create your password'}</h1>

        {status === 'checking' && (
          <div className='password-status'><span className='payment-spinner' /> Checking your secure link…</div>
        )}

        {(status === 'ready' || status === 'saving') && (
          <form onSubmit={handleSubmit} className='password-form'>
            <p className='section-copy'>Set the password for <strong>{email}</strong>.</p>
            <label htmlFor='newPassword'>New password</label>
            <input id='newPassword' type='password' autoComplete='new-password' value={password} onChange={(event) => setPassword(event.target.value)} required />
            <label htmlFor='confirmPassword'>Confirm password</label>
            <input id='confirmPassword' type='password' autoComplete='new-password' value={confirmation} onChange={(event) => setConfirmation(event.target.value)} required />
            {error && <p className='receipt-error' role='alert'>{error}</p>}
            <button className='cta-button primary full-width' type='submit' disabled={status === 'saving'}>
              {status === 'saving' ? 'Securing password…' : 'Save password'}
            </button>
          </form>
        )}

        {status === 'invalid' && <p className='payment-message error' role='alert'>{error}</p>}
        {status === 'complete' && (
          <>
            <p className='section-copy'>You can now sign in to the Mukwei Operations iOS app.</p>
            <Link to='/' className='cta-button primary full-width'>Return to Mukwei Gin</Link>
          </>
        )}
      </section>
    </main>
  );
}

export default ResetPassword;
